import { FC, useState } from "react";
import logo from "../../assets/ar encyclopedy.png";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageContext";
import LanguageDrawer from "./LanguageDrawer";
import AdminDrawer from "../adminDrawer/AdminDrawer";

interface PackageListHeaderProps {
  hideLogo?: boolean;
}

const PackageListHeader: FC<PackageListHeaderProps> = ({ hideLogo }) => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [languageDrawerOpen, setLanguageDrawerOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogoClick = () => {
    navigate("/", { replace: true });
  };

  const toggleLanguageDrawer = (open: boolean) => () => {
    setLanguageDrawerOpen(open);
  };

  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };

  return (
    <header className="bg-white dark:bg-darkSecondaryBackground py-4 px-4 sm:px-6 lg:px-8 shadow w-full relative">
      <div className="flex justify-between items-center w-full">
        <div className="flex items-center">
          <button
            onClick={toggleDrawer(true)}
            className="text-black dark:text-white"
          >
            <MenuIcon />
          </button>
          <AdminDrawer open={drawerOpen} onClose={toggleDrawer(false)} />
        </div>
        <div className="absolute left-1/2 transform -translate-x-1/2 ">
          {!hideLogo && (
            <img
              src={logo}
              alt="Logo"
              className="h-8 w-auto cursor-pointer"
              onClick={handleLogoClick}
            />
          )}
        </div>
        <div className="flex items-center">
          <IconButton onClick={toggleLanguageDrawer(true)}>
            <img
              src={`/flags/${language}.png`}
              alt={language}
              className="h-6 w-auto"
            />
          </IconButton>
          <LanguageDrawer
            open={languageDrawerOpen}
            onClose={toggleLanguageDrawer(false)}
          />
        </div>
      </div>
    </header>
  );
};

export default PackageListHeader;
